import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
    selector: 'ng-template[advSidebarExpanded]',
})
export class SidebarExpandedDirective {
    public readonly templateRef = inject<TemplateRef<never>>(TemplateRef);
}

@Directive({
    selector: 'ng-template[advSidebarIcon]',
})
export class SidebarIconDirective {
    public readonly templateRef = inject<TemplateRef<never>>(TemplateRef);
}
